"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = require("axios");
var index_1 = require("../types/index");
function xhrError(_a) {
    var code = _a.code, config = _a.config, _b = _a.status, status = _b === void 0 ? 0 : _b, _c = _a.data, data = _c === void 0 ? {} : _c;
    var err = {
        name: 'XhrError',
        message: code,
        code: code,
        data: data,
        status: status,
        config: config,
    };
    return Promise.reject(err);
}
function normalizeAxiosError(error) {
    // timeout
    if (error.code === 'ECONNABORTED') {
        return xhrError({
            code: index_1.XhrErrorCode.TIMEOUT_ERROR,
            config: error.config,
        });
    }
    // cancel
    if (axios_1.default.isCancel(error)) {
        return xhrError({
            code: index_1.XhrErrorCode.CANCEL_ERROR,
            config: error.config,
        });
    }
    // service error, 400 401 404 500 502...
    if (error.response) {
        if (error.response.status === 401) {
            return xhrError({
                code: index_1.XhrErrorCode.TOKEN_ERROR,
                status: error.response.status,
                data: error.response.data,
                config: error.config,
            });
        }
        if (error.response.status === 403) {
            return xhrError({
                code: index_1.XhrErrorCode.FORBIDDEN_ERROR,
                status: error.response.status,
                data: error.response.data,
                config: error.config,
            });
        }
        if (error.response.status === 404) {
            return xhrError({
                code: index_1.XhrErrorCode.NOTFOUND_ERROR,
                status: error.response.status,
                data: error.response.data,
                config: error.config,
            });
        }
        if (error.response.status >= 400 && error.response.status < 500) {
            return xhrError({
                code: index_1.XhrErrorCode.CLIENT_ERROR,
                status: error.response.status,
                data: error.response.data,
                config: error.config,
            });
        }
        if (error.response.status >= 500 && error.response.status < 600) {
            return xhrError({
                code: index_1.XhrErrorCode.SERVER_ERROR,
                status: error.response.status,
                data: error.response.data,
                config: error.config,
            });
        }
        return xhrError({
            code: index_1.XhrErrorCode.UNKNOWN_ERROR,
            config: error.config,
        });
    }
    // network error
    if (error.request) {
        return xhrError({
            code: index_1.XhrErrorCode.NETWORK_ERROR,
            config: error.config,
        });
    }
    // throw error on request config?
    return xhrError({
        code: index_1.XhrErrorCode.UNKNOWN_ERROR,
        config: error.config,
    });
}
exports.default = normalizeAxiosError;
